export const INSERE_DADOS_OPERADOR = 'INSERE_DADOS_OPERADOR'
export const ATUALIZA_DADOS_OPERADOR = 'ATUALIZA_DADOS_OPERADOR'
export const GET_DADOS_RELATORIO_OPERADOR_INDIVIDUAL = 'GET_DADOS_RELATORIO_OPERADOR_INDIVIDUAL'
